import { Outlet } from "react-router-dom";
import { getConsumerConfig } from "../../consumers";
import { useConsumer } from "../ConsumerProvider";
import { BrandLogo } from "./BrandLogo";
import styles from "./BrandLayout.module.scss";

/** id of the shared header, for screens that move focus to it (Consent). */
export const BRAND_HEADER_ID = "idme-brand-header";

/**
 * Router layout for the verification screens. With `fragnoLogoEnabled`
 * (VEX-7983, `vex_7983_fragno_logo_enabled`) it renders the one page header and
 * BrandLogo for every screen beneath it; screens then hide their own headers.
 * Flag off, the wrapper is `display: contents`, so the screen lays out as before the flag.
 *
 * The element tree is the same either way. The flag usually arrives with
 * IDME_INIT, after the screen has mounted; swapping `<Outlet />` for a wrapper
 * then would remount the screen, which re-sends IDME_READY to an SDK that only
 * answers the first one, and the flow hangs on its spinner.
 */
export function BrandLayout() {
  const { fragnoLogoEnabled, consumer } = useConsumer();

  const themeClass = fragnoLogoEnabled ? getConsumerConfig(consumer)?.themeClass : undefined;
  return (
    <div className={[fragnoLogoEnabled ? styles.shell : styles.passthrough, themeClass].filter(Boolean).join(" ")}>
      {fragnoLogoEnabled && (
        <header id={BRAND_HEADER_ID} tabIndex={-1} className={styles.header}>
          <BrandLogo />
        </header>
      )}
      <Outlet />
    </div>
  );
}
